import axios from 'axios'

export default {
  state: {
    semesterCourses: [],
    courseInfo: {}
  },
  mutations: {
    setSemesterCourses(state, payload) {
      state.semesterCourses = payload
    },
    setCourseManagerData (state, payload) {
      state.courseInfo = payload
      state.courseInfo.grade = state.courseInfo.grade.split(',')
    }
  },
  actions: {
    getSemesterCourses({ commit, dispatch, state }, semester_id) {
      axios.get('/api/courses/by-semester/' + semester_id).then(response => {
        state.semesterCourses = response.data.courses
      })
      .catch((error) => {
        dispatch('checkToken', error)
      })
    },
    getCourseManagerData({ commit, dispatch, state }, id) {
      axios.get('/api/courses/' + id).then(response => {
        commit('setCourseManagerData', response.data.course)
      })
      .catch(error => {
        dispatch('checkToken', error)
      })
    },
    createCourse({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) =>{
        axios.post('/api/courses', payload).then((response) => {
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    editCourseDetails({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/courses/' + payload.id, payload)
          .then((response) => {
            resolve()
          })
          .catch((error) => {
            dispatch('checkToken', error).then(() => {
              commit('setValidationErrors', error)
              reject()
            })
          })
      })
    },
    deleteCourse({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        axios.delete('/api/courses/' + id).then(response => {
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })  
      })      
    },
    courseToggleHidden({ commit, dispatch, state }, payload) {
      axios.post('/api/courses/toggle-hidden/' + payload).then((response) => {
        state.semesterCourses = response.data.courses
      })
      .catch((error) => {
        dispatch('checkToken', error)
      })
    },
    copyCourse({ commit, dispatch, state }, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/api/courses/copy/data', { params: payload })
        .then(response => {
          state.courseInfo = response.data.course
          resolve()
        })
        .catch(error => {
          dispatch('checkToken', error).then(() => {
            commit('setValidationErrors', error)
            reject()
          })
        })
      })
    }
  }
}


